import { jsx as a, jsxs as $, Fragment as S } from "react/jsx-runtime";
import { useState as w, useRef as V, useCallback as I, useEffect as v } from "react";
import { Box as H, Flex as B } from "@chakra-ui/react";
import { rgbToHex as C, isBrokerNumberValid as O, isIssuerNumberValid as b } from "./brokerIssuerBannerFunctions.mjs";
const y = {
  number: void 0,
  path: void 0,
  img: void 0,
  fillColorLeft: void 0,
  fillColorRight: void 0
}, G = ({
  alt: k = "Banner",
  brokerNumber: m,
  containerAs: o = "span",
  fillColorLeft: h,
  fillColorRight: p,
  hideColorFill: g = !1,
  imageProps: j,
  issuerNumber: i,
  ...L
}) => {
  const [R, f] = w(!0), [e, r] = w({
    ...y
  }), d = V(null), l = I(
    (u, s) => {
      const n = new Image();
      n.crossOrigin = "Anonymous";
      const t = `https://www.mysgi.ca/images/banners/${u}.jpeg`;
      n.src = t, n.onload = () => {
        r({
          ...e,
          number: u,
          path: t,
          img: n
        }), f(!1);
      }, n.onerror = () => {
        s == null || s();
      };
    },
    [e]
  ), c = I(() => {
    r({
      ...y
    }), f(!1);
  }, []);
  return v(() => {
    e.number && /^\d{4,6}$/.test(e.number) && f(!1);
  }, [e.number]), v(() => {
    if (e.img && !g && o === "div" && d.current) {
      const s = d.current.getContext("2d");
      s == null || s.drawImage(e.img, 0, 0);
      const n = s == null ? void 0 : s.getImageData(0, e.img.height / 2, 1, 1).data, t = s == null ? void 0 : s.getImageData(e.img.width - 1, e.img.height / 2, 1, 1).data;
      r({
        ...e,
        fillColorLeft: C(n == null ? void 0 : n[0], n == null ? void 0 : n[1], n == null ? void 0 : n[2]),
        fillColorRight: C(t == null ? void 0 : t[0], t == null ? void 0 : t[1], t == null ? void 0 : t[2])
      });
    }
  }, [e.img, o, g]), v(() => {
    O(m) ? l(m, () => {
      b(i) ? l(i, () => f(!1)) : c();
    }) : b(i) ? l(i, () => {
      c();
    }) : c();
  }, [m, i]), !R && e.number ? /* @__PURE__ */ a(
    H,
    {
      as: o === "span" ? "span" : "div",
      display: o === "div" ? "flex" : "inline-block",
      ...o === "div" && {
        justifyContent: "center",
        flexDir: "row"
      },
      ...L,
      children: /* @__PURE__ */ $(S, { children: [
        o === "div" && /* @__PURE__ */ a(
          B,
          {
            ...!g && {
              backgroundColor: `${h || e.fillColorLeft}`
            },
            flex: 1
          }
        ),
        /* @__PURE__ */ a("img", { src: e.path, alt: k, ...j }),
        o === "div" && /* @__PURE__ */ a(
          B,
          {
            ...!g && {
              backgroundColor: `${p || e.fillColorRight}`
            },
            flex: 1
          }
        ),
        /* @__PURE__ */ a(
          "canvas",
          {
            ref: d,
            width: "960px",
            height: "125px",
            style: { margin: "0 auto", display: "none" }
          }
        )
      ] })
    }
  ) : null;
};
export {
  G as BrokerIssuerBanner
};
